import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IStyleProps {
  bgColor?: string;
}

export const Root = styled.div`
  flex-grow: 1;
  background-color: ${(props: IStyleProps) => (props.bgColor ?? C.GENERIC_GRAY)};
  box-sizing: border-box;
  padding: 11px 0px 11px 0px;
  font-family: Roboto;
`;

export const Layers = styled.div`
  display: block;
  width: 100%;
`;